import { loadEnv } from '../../shims/load-env';

export const MOONSHOT_API_KEY_ENV_VARIABLE_NAME = 'MOONSHOT_API_KEY';
export const MOONSHOT_DEFAULT_MODEL_ENV_VARIABLE_NAME =
  'MOONSHOT_DEFAULT_MODEL';

export const DEFAULT_KIMI_BASE_URL = 'https://api.moonshot.cn/v1';
export const DEFAULT_KIMI_MODEL = 'kimi-k2.6';

export function getDefaultKimiKey(): string | undefined {
  return loadEnv()[MOONSHOT_API_KEY_ENV_VARIABLE_NAME];
}

export function getDefaultKimiBaseURL(): string {
  return DEFAULT_KIMI_BASE_URL;
}

export function getDefaultKimiModel(): string {
  return (
    loadEnv()[MOONSHOT_DEFAULT_MODEL_ENV_VARIABLE_NAME] ?? DEFAULT_KIMI_MODEL
  );
}
